// 法务管理-路由
var LegalWaitingCollectCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-waiting-collect-case-manage.vue');
}; //法务待分配
var LegalTeamCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-team-case-manage.vue');
}; //团队案件池
var LegalPersonCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-person-case-manage.vue');
}; //个人案件池
var LegalRecoverCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-recover-case-manage.vue');
}; //回收案件池
var LegalReturnCCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-returnc-case-manage.vue');
}; //归C案件池
var LegalSettleCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-settle-case-manage.vue');
}; //结清案件池
var LegalStopCaseManage = function () {
    return import('~/pages/legally-collection-manage/legal-stop-case-manage.vue');
}; //停催案件池
var LegalUrgeActionFlow = function () {
    return import('~/pages/legally-collection-manage/legal-urge-action-flow.vue');
}; //法务行动记录
export default [
    {
        path: '/legally-collection-manage/legal-waiting-collect-case-manage',
        name: 'legal-waiting-collect-case-manage',
        component: LegalWaitingCollectCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-team-case-manage',
        name: 'legal-team-case-manage',
        component: LegalTeamCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-person-case-manage',
        name: 'legal-person-case-manage',
        component: LegalPersonCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-recover-case-manage',
        name: 'legal-recover-case-manage',
        component: LegalRecoverCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-returnc-case-manage',
        name: 'legal-returnc-case-manage',
        component: LegalReturnCCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-settle-case-manage',
        name: 'legal-settle-case-manage',
        component: LegalSettleCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-stop-case-manage',
        name: 'legal-stop-case-manage',
        component: LegalStopCaseManage,
    },
    {
        path: '/legally-collection-manage/legal-urge-action-flow',
        name: 'legal-urge-action-flow',
        component: LegalUrgeActionFlow,
    },
];
